/**
 * Espelha CriarNotaFiscalSaidaOcorrenciaRequest do OrquestradorVendas: anotação do usuário no histórico
 * da NF-e de saída. Tipo, origem e usuário são postos pelo servidor.
 */
export class CriarNotaFiscalSaidaOcorrenciaRequest {
  /** Texto do usuário, até 1000 caracteres. */
  descricao: string;
  /** Data do fato, sem futuro; ausente = agora. */
  dataOcorrencia: string | null = null;
}
